export default "__VITE_ASSET__5cc7e748__"